// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__19BMU","row":"Node_row__2y507","label":"Node_label__3hJ0h","footer":"Node_footer__2uOVR"};